export const logAPIs = {
  getLogs: {
    url: 'logs',
    method: 'get',
    isAuthEnabled: true,
  },
};
